import React, { useState, useEffect } from "react";
import { NavLink, useOutlet } from "react-router-dom";
import { useDispatch } from 'react-redux'
import SettingsList from '../settings-list'
import { getPaymentProcessorConfigurationForms } from '../../../slices/paymentprocessorconfiguration'

import * as Svg from "../../../components/svg";

const SettingsContainer = () => {

    const dispatch = useDispatch()
    const outlet = useOutlet()

    useEffect(() => {
        dispatch(getPaymentProcessorConfigurationForms())
    }, [])


    return (
        <>
            <div className="left narrow">
                <SettingsList />
            </div>
            <div className={`right ${outlet ? 'show-column' : '' }`}>
                <>
                    <div className="d-flex d-xl-none align-items-center justify-content-center close-container">
                        <NavLink className="nav-link" to="/settings">
                            <Svg.SvgBackarrow />
                            {gettext('Settings')}
                        </NavLink>
                    </div>
                    {outlet}
                </>
            </div>
        </>
    )

}

export default SettingsContainer